import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'df-funnel-statistics',
  templateUrl: './funnel-statistics.component.html',
  styleUrls: ['./funnel-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunnelStatisticsComponent {}
